export interface IBillingAccountInformation {
	accountId: string;
	accountType: string;
	billingAccountEntryId: string;
	billingAccountName: string;
	billingAccountType: 'MOBILE_POSTPAID' | 'MOBILE_PREPAID' | 'FIXED' | 'MIXED' | 'INTERNET' | 'UNKNOWN';
	billingId: string;
	email: string;
	phoneNumber: string;
}

const model: types.models.InputModel = {
	accountId: 'response.getBillingAccountInformationResponse.billingAccountData.accountId',
	accountType: 'response.getBillingAccountInformationResponse.billingAccountData.accountType',
	billingAccountEntryId: 'response.getBillingAccountInformationResponse.billingAccountData.billingAccountEntryId',
	billingAccountName: 'response.getBillingAccountInformationResponse.billingAccountData.billingAccountName',
	billingAccountType: 'response.getBillingAccountInformationResponse.billingAccountData.billingAccountType',
	billingId: 'response.getBillingAccountInformationResponse.billingAccountData.billingId',
	email: 'response.getBillingAccountInformationResponse.billingAccountData.email',
	phoneNumber: 'response.getBillingAccountInformationResponse.billingAccountData.phoneNumber',
};

export default model;
